export default {
  methods: {
    trad (object) {
      const locale = this.$store.getters.selectedLang
      const fallback = this.$store.getters.fallbackLang
      if (object[locale]) {
        return object[locale]
      } else {
        return object[fallback]
      }
    }
  }
}
